import styled from 'styled-components';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import {
  makeStyles,
  createStyles,
  TextField as TextInput
} from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb15: {
      'margin-bottom': '15px'
    },
    input: {
      backgroundColor: '#FFFFFF',
      borderRadius: '15px',
      width: '100%',
      boxShadow: '5px 5px rgba(60,128,209,0.09)'
    },
    center: {
      justifyContent: 'center'
    },
    title: {
      color: '#12253F',
      fontSize: '17px',
      fontWeight: 'bold',
      textAlign: 'center'
    },
    btnCancel: {
      '&:hover': {
        backgroundColor: '#d5d5d5'
      }
    },
    btnSubmit: {
      '&:hover': {
        backgroundColor: '#023EE3'
      }
    },
    errorSubmit: {
      width: 'fit-content',
      margin: '0 auto'
    }
  })
);

export const DialogEmail = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 12px 19px 0 rgba(60, 128, 209, 0.09);
    width: 960px;
    min-width: 600px;
    min-height: 220px;
    overflow: auto;
  }
`;

export const DialogTitleWrapper = styled(DialogTitle)`
  .MuiTypography-h6 {
    font-weight: bold;
  }
`;

export const FormLabel = styled.p`
  color: #102341;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
`;

export const TextInputWrapper = styled(TextInput)`
  .MuiOutlinedInput-root {
    border-radius: 6px;
  }
`;
